import './Formula.svelte.css';
/* src/components/Formula.svelte generated by Svelte v3.57.0 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	element,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import { expressionStore } from "./stores.js";
import ExpressionParser from "./ExpressionParser.svelte.js";
import LocalizedExpression from "./LocalizedExpression.svelte.js";

function create_else_block(ctx) {
	let t0;
	let t1;

	return {
		c() {
			t0 = text("Dependências faltantes: ");
			t1 = text(/*missingDependencies*/ ctx[1]);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, t1, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*missingDependencies*/ 2) set_data(t1, /*missingDependencies*/ ctx[1]);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
		}
	};
}

// (15:4) {#if wsItem.evaluation !== undefined}
function create_if_block(ctx) {
	let localizedexpression;
	let current;

	localizedexpression = new LocalizedExpression({
			props: {
				stringified: /*wsItem*/ ctx[0].evaluation.toString()
			}
		});

	return {
		c() {
			create_component(localizedexpression.$$.fragment);
		},
		m(target, anchor) {
			mount_component(localizedexpression, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const localizedexpression_changes = {};
			if (dirty & /*wsItem*/ 1) localizedexpression_changes.stringified = /*wsItem*/ ctx[0].evaluation.toString();
			localizedexpression.$set(localizedexpression_changes);
		},
		i(local) {
			if (current) return;
			transition_in(localizedexpression.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(localizedexpression.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(localizedexpression, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div1;
	let expressionparser;
	let t0;
	let div0;
	let current_block_type_index;
	let if_block;
	let t1;
	let div2;
	let button;
	let current;
	let mounted;
	let dispose;

	expressionparser = new ExpressionParser({
			props: { current: /*wsItem*/ ctx[0].expression }
		});

	const if_block_creators = [create_if_block, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*wsItem*/ ctx[0].evaluation !== undefined) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			div1 = element("div");
			create_component(expressionparser.$$.fragment);
			t0 = space();
			div0 = element("div");
			if_block.c();
			t1 = space();
			div2 = element("div");
			button = element("button");
			button.textContent = "x";
			attr(div0, "class", "result svelte-1voj0sp");
			attr(div1, "class", "expression-holder svelte-1voj0sp");
			attr(button, "title", "Deletar");
			attr(button, "class", "svelte-1voj0sp");
			attr(div2, "class", "actions svelte-1voj0sp");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			mount_component(expressionparser, div1, null);
			append(div1, t0);
			append(div1, div0);
			if_blocks[current_block_type_index].m(div0, null);
			insert(target, t1, anchor);
			insert(target, div2, anchor);
			append(div2, button);
			current = true;

			if (!mounted) {
				dispose = listen(button, "click", /*click_handler*/ ctx[3]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			const expressionparser_changes = {};
			if (dirty & /*wsItem*/ 1) expressionparser_changes.current = /*wsItem*/ ctx[0].expression;
			expressionparser.$set(expressionparser_changes);
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(div0, null);
			}
		},
		i(local) {
			if (current) return;
			transition_in(expressionparser.$$.fragment, local);
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(expressionparser.$$.fragment, local);
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			destroy_component(expressionparser);
			if_blocks[current_block_type_index].d();
			if (detaching) detach(t1);
			if (detaching) detach(div2);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $expressionStore;
	component_subscribe($$self, expressionStore, $$value => $$invalidate(2, $expressionStore = $$value));
	let { wsItem } = $$props;
	let missingDependencies;
	const click_handler = () => expressionStore.remove(wsItem.expression);

	$$self.$$set = $$props => {
		if ('wsItem' in $$props) $$invalidate(0, wsItem = $$props.wsItem);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*wsItem, $expressionStore*/ 5) {
			$: $$invalidate(1, missingDependencies = wsItem.expression.dependencies.filter(dep => !$expressionStore.has(dep)).join(", "));
		}
	};

	return [wsItem, missingDependencies, $expressionStore, click_handler];
}

class Formula extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { wsItem: 0 });
	}
}

export default Formula;